import { dossierTypes } from "@/lib/formatter/dossiers";
import { DossierFilterField } from "../types/DossierFilterField.interface";

const dossierTypeOptions = Object.entries(dossierTypes).map(
  ([value, label]) => ({ label, value }),
);

export const dossierFilterFields: DossierFilterField[] = [
  {
    name: "licenseplate",
    label: "Kenteken",
    type: "licenseplate",
    placeholder: "12-AB-CD",
  },
  {
    name: "drivername",
    label: "Naam berijder",
    type: "text",
    placeholder: "Jan Janssen",
  },
  {
    name: "insurerName",
    label: "Verzekeraar",
    type: "text",
    placeholder: "Verzekeraar naam",
  },
  {
    name: "leaseCompanyName",
    label: "Leasemaatschappij",
    type: "text",
    placeholder: "Leasemaatschappij naam",
  },
  {
    name: "externalReference",
    label: "Externe referentie",
    type: "text",
    placeholder: "Externe referentie",
  },
  {
    name: "servicePartnerId",
    label: "Hersteller",
    type: "select",
    placeholder: "Selecteer hersteller",
  },
  {
    name: "preferredServicePartner",
    label: "Preferred partner",
    type: "boolean",
  },
  {
    name: "dossierType",
    label: "Dossiertype",
    type: "select",
    placeholder: "Selecteer dossiertype",
    options: dossierTypeOptions,
  },
  {
    name: "archived",
    label: "Archief",
    type: "boolean",
  },
];
